// extracted by css-extract-rspack-plugin
export default {"wrapper":"L8hT_","bottom_space":"p8iz5","bottomSpace":"p8iz5","preloader":"VuqwS","video":"gFlj3","visible":"YjBKV"};